<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Averaging Agreements</h5>
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="addAveragingAgreement"
            >
              Add Averaging Agreement
            </button>
          </div>

          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-lg-12 col-sm-12">
                <ag-grid-vue
                  class="ag-theme-alpine-dark"
                  style="width: 100%; height: 100%"
                  :columnDefs="columnDefs"
                  :rowData="filteredAgreements"
                  :gridOptions="gridOptions"
                  :frameworkComponents="frameworkComponents"
                  :context="context"
                >
                </ag-grid-vue>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add User Modal -->
    <modal-wrapper :isOpen="showAddModal">
      <div
        v-if="showAddModal"
        class="customModal fade"
        v-bind:class="{ show: showAddModal }"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h6 class="modal-title">Add Averaging Agreement</h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <el-form>
                <el-form-item label="Agreement Name:">
                  <el-input
                    type="text"
                    id="name"
                    name="name"
                    maxlength="25"
                    show-word-limit
                    v-model="selectedAgreement.name"
                    class="el-dark-input"
                  />
                </el-form-item>
                <el-form-item label="Start Date:">
                  <div class="form-group">
                    <el-date-picker
                      v-model="selectedAgreement.startDate"
                      type="date"
                      align="right"
                      unlink-panels
                      format="MMM dd, yy"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="Total Hours Until OT:">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      The total hours is the amount of regular hours that need
                      to be worked over the agreement's timeframe until overtime
                      is reached.
                    </div>
                    <i class="el-icon-info mr-2"></i>
                  </el-tooltip>
                  <el-input-number
                    class="el-dark-input"
                    v-model="selectedAgreement.hoursBeforeOT"
                    :max="getMaxHours()"
                    :min="0"
                    :step="0.25"
                    :precision="2"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Daily Hours Until OT: (Optional)">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      Daily hours is an optional field that can be set that can
                      specify if an employee will recieve overtime over a set
                      amount of hours in a day. The overtime hours do not count
                      to the averaginge agreement's Total Hours.
                    </div>
                    <i class="el-icon-info mr-2"></i>
                  </el-tooltip>
                  <el-input-number
                    class="el-dark-input"
                    v-model="selectedAgreement.dailyHoursBeforeOT"
                    :max="24"
                    :min="0"
                    :step="0.25"
                    :precision="2"
                    placeholder="N/A"
                  >
                  </el-input-number>
                </el-form-item>
              </el-form>
              <el-form :inline="true">
                <el-form-item label="Time Frame:">
                  <el-input-number
                    class="el-dark-input"
                    v-model="selectedAgreement.timeFrame"
                    :max="getMaxTimeFrame()"
                    :min="0"
                    :step="1"
                    :precision="0"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item>
                  <el-select
                    class="el-dark-input"
                    v-model="selectedAgreement.timeFrameUnit"
                    @change="checkTimeFrame()"
                  >
                    <el-option
                      v-for="item in timeFrameUnitOptions"
                      :key="`${item.value}`"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option
                  ></el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                Close
              </button>
              <button
                type="button"
                class="btn bg-primary loaderButton"
                v-on:click="submitAveragingAgreement()"
              >
                <spring-spinner
                  :animation-duration="3000"
                  :size="15"
                  color="white"
                  v-if="addAgreement_loading"
                />
                <div v-else>Add Averaging Agreement</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal-wrapper>
  </div>
</template>

<script>
import { db } from '../assets/js/firebase/db.js';
import { SpringSpinner } from 'epic-spinners';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import AveragingAgreementTableButtons from '../components/childComponents/averagingAgreementTableButtons.vue';
import { MessageBox } from 'element-ui';
import moment from 'moment';
import ModalWrapper from './modalWrapper.vue';

export default {
  name: 'averagingAgreements',
  props: {
    companySettingsID: String,
    averagingAgreements: Array,
    users: Array
  },
  components: {
    AgGridVue,
    SpringSpinner,
    ModalWrapper
  },
  data() {
    return {
      showAddModal: false,
      addAgreement_loading: false,

      columnDefs: null,
      gridOptions: null,
      context: null,

      selectedAgreement: {
        name: null,
        startDate: null,
        hoursBeforeOT: null,
        dailyHoursBeforeOT: null,
        timeFrame: null,
        timeFrameUnit: null,
        enabled: null,
        deleted: false
      },
      timeFrameUnitOptions: [
        {
          value: 'days',
          label: 'days'
        },
        {
          value: 'weeks',
          label: 'weeks'
        },
        {
          value: 'months',
          label: 'months'
        }
      ],

      pickerOptions: {
        disabledDate(time) {
          return new Date(moment().endOf('day')) >= time;
        }
      }
    };
  },
  methods: {
    addAveragingAgreement() {
      this.showAddModal = true;
      this.selectedAgreement.name = null;
      this.selectedAgreement.startDate = null;
      this.selectedAgreement.hoursBeforeOT = 0;
      this.selectedAgreement.dailyHoursBeforeOT = undefined;
      this.selectedAgreement.timeFrame = 0;
      this.selectedAgreement.timeFrameUnit = 'days';
    },
    async submitAveragingAgreement() {
      if (this.validateEntry()) {
        try {
          this.addAgreement_loading = true;

          this.selectedAgreement.enabled = true;
          this.selectedAgreement[
            'initialStartDate'
          ] = this.selectedAgreement.startDate;

          let endDate = new Date(
            moment(this.selectedAgreement.startDate)
              .add(
                this.selectedAgreement.timeFrame,
                this.selectedAgreement.timeFrameUnit
              )
              .subtract(1, 'days')
              .endOf('day')
          );

          this.selectedAgreement['timeSpans'] = [
            {
              startDate: this.selectedAgreement.startDate,
              endDate: endDate
            }
          ];
          if (this.selectedAgreement.dailyHoursBeforeOT === undefined) {
            this.selectedAgreement.dailyHoursBeforeOT = null;
          }
          await db
            .collection(
              `companySettings/${this.companySettingsID}/averagingAgreements`
            )
            .add(this.selectedAgreement);

          this.addAgreement_loading = false;
          this.showSuccess('Averaging agreement succesfully created');
          this.showAddModal = false;
          this.$emit('getAgreements');
        } catch (error) {
          console.log(error);
          this.showError('Error adding averaging agreement');
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    async deleteAgreement(id, index) {
      try {
        // TODO: change delete message wording
        await MessageBox.confirm(
          `Are you sure you want to delete this agreement? This will apply retroactively to all time cards added under this agreement, and they will be calculated normally. If you would rather just disable this agreement for all future timecards, simply toggle the enabled switch`,
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        );

        await db
          .collection(
            `companySettings/${this.companySettingsID}/averagingAgreements`
          )
          .doc(id)
          .update({ deleted: true, enabled: false });

        this.filteredAgreements.splice(index, 1);

        //get all the users that had this agreement as their averaging agreement and update their doc with a null value
        let promises = [];
        let usersWithAgreement = this.users.filter(user => {
          return (
            user.averagingAgreement !== null &&
            user.averagingAgreement.docID === id
          );
        });
        //update each user with a null value for their averagingAgreement
        for (let i = 0; i < usersWithAgreement.length; i++) {
          promises.push(
            db
              .collection('users')
              .doc(usersWithAgreement[i].edit.uid)
              .update({ averagingAgreement: null })
          );
        }

        await Promise.all(promises);
        this.$emit('getAgreements');

        this.showSuccess('Averaging agreement succesfully deleted');
      } catch (error) {
        if (error !== 'cancel') {
          console.log(error);
          this.showError('Error deleting averaging agreement');
        }
      }
    },
    async disableAgreement(id, enabled, index) {
      try {
        await db
          .collection(
            `companySettings/${this.companySettingsID}/averagingAgreements`
          )
          .doc(id)
          .update({ enabled: enabled });
        if (enabled) {
          this.showSuccess('Averaging Agreement succesfully enabled');
        } else {
          this.showSuccess('Averaging Agreement succesfully disabled');
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showAddModal = false;
    },
    getMaxHours() {
      //TODO: Calculate the max hours based upon the time frame/time frame unit
      return 50000;
    },
    getMaxTimeFrame() {
      if (this.selectedAgreement.timeFrameUnit === 'days') {
        return 365;
      } else if (this.selectedAgreement.timeFrameUnit === 'weeks') {
        return 52;
      } else if (this.selectedAgreement.timeFrameUnit === 'months') {
        return 12;
      }
    },
    checkTimeFrame() {
      let max = this.getMaxTimeFrame();
      if (this.selectedAgreement.timeFrame > max) {
        this.selectedAgreement.timeFrame = max;
      }
    },
    validateEntry() {
      let allEntriesValid = true;
      if (
        this.selectedAgreement.name === null ||
        this.selectedAgreement.name.trim() === ''
      ) {
        allEntriesValid = false;
      } else if (this.selectedAgreement.startDate === null) {
        allEntriesValid = false;
      } else if (this.selectedAgreement.hoursBeforeOT === null) {
        allEntriesValid = false;
      } else if (this.selectedAgreement.timeFrame === null) {
        allEntriesValid = false;
      } else if (this.selectedAgreement.timeFrameUnit === null) {
        allEntriesValid = false;
      }

      return allEntriesValid;
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'tableButtonsRenderer',
        minWidth: 130
      },
      { headerName: 'Name', field: 'name' },
      { headerName: 'Start Date', field: 'displayDate' },
      { headerName: 'Total Hours Until OT', field: 'hoursBeforeOT' },
      { headerName: 'Daily Hours Until OT', field: 'dailyHoursBeforeOT' },
      { headerName: 'Time Frame', field: 'combinedTimeFrame' }
    ];
    this.gridOptions = {
      domLayout: 'autoHeight'
    };
    this.gridOptions.rowStyle = {
      background: '#353f53',
      borderTop: '1px solid rgba(255,255,255,.1)'
    };
    this.frameworkComponents = {
      tableButtonsRenderer: AveragingAgreementTableButtons
    };
    this.context = { componentParent: this };
  },
  mounted() {},
  computed: {
    filteredAgreements() {
      return this.averagingAgreements.filter(
        agreement => agreement.deleted === false
      );
    }
  }
};
</script>
